// export const API_URL = 'http://192.168.0.52:8080/v1/'
// export const API_URL = "http://ec2-54-190-35-48.us-west-2.compute.amazonaws.com:3004/";
export const API_URL = "https://daoapi.tomi.com/v1/";
